import Utils from "../Utils";
import router from "./../router";
import services from "./../services";

const strict = true;
const getDefaultState = () => {
  return {
    step: 1,
    passwordRecoveryRequest: null,
    username: null
  };
};

const state = getDefaultState();

const getters = {
  step: state => state.step,
  passwordRecoveryRequest: state => state.passwordRecoveryRequest,
  addressData: state => state.addressData,
  username: state => state.username
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  updateUsername(state, username) {
    state.username = username;
  },
  loadingPasswordRecoveryRequest(state) {
    state.step = 1;
    state.passwordRecoveryRequest = null;
  },
  passwordRecoveryRequestLoaded(state, passwordRecoveryRequest) {
    state.passwordRecoveryRequest = passwordRecoveryRequest;
  },
  updatePasswordRecoveryForm(state, passwordRecoveryRequest) {
    Object.assign(state.passwordRecoveryRequest, passwordRecoveryRequest);
  },
  updatePasswordRecoveryStep(state, step) {
    state.step = step;
  },
  updatePwdReqRegion(state, { region }) {
    Object.assign(state.passwordRecoveryRequest.region, region);
  },
  updatePwdReqProvince(state, { province }) {
    Object.assign(state.passwordRecoveryRequest.province, province);
  },
  updatePwdReqCity(state, { city }) {
    Object.assign(state.passwordRecoveryRequest.city, city);
  }
};

const actions = {
  initPasswordRecoveryRequest({ commit }) {
    commit("loadingPasswordRecoveryRequest");
    const passwordRecoveryRequest = {
      username: "", //SDFSDG21S54D324A
      email: "",
      mobileNumber: "",
      confirmMobile: false,
      documentType: "",
      documentNumber: "",
      confirmDocumentNumber: false,
      region: {},
      province: {},
      city: {},
      cap: "",
      saveData: false
    };
    commit("passwordRecoveryRequestLoaded", passwordRecoveryRequest);
  },
  sendPasswordRecoveryRequest({ commit, state }) {
    let payload = {
      username: state.username,
      portal: "HFPORTAL"
    };

    return services.passwordRecoveryService
      .passwordRecovery(payload)
      .then(() => {
        let success = {
          title: "homepage.password-recovery.success.title",
          message: "homepage.password-recovery.success.msg",
          closeButtonLabel: "homepage.password-recovery.success.btn",
          closeButtonClb: () => {
            router.push({
              name: "login"
            });
          }
        };
        commit("success/openSuccessDialog", success, {
          root: true
        });
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "passwordRecovery";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  goBackToLogin({ commit }) {
    commit("RESET");
    router.push({
      name: "login"
    });
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
